<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter5">
<h1><a id="page_23"></a><a href="#/003toc#ch5">Minestrone with Parmigiano-Reggiano</a></h1>
<p class="noindent">The word <i>minestrone</i> in Italian means “without stock,” so it is essentially a vegetarian soup that uses the juices of the vegetables as its stock. This soup is terrific in the slow cooker. Even though there doesn’t seem to be enough liquid for the soup at first glance, the vegetables will add a lot of liquid to the pot as they cook. For a strictly vegan soup, omit the cheese rind.</p>
<p class="noindent">2 tablespoons extra-virgin olive oil</p>
<p class="noindent">3 cloves garlic, minced</p>
<p class="noindent">1 cup coarsely chopped sweet onion</p>
<p class="noindent">1 cup coarsely chopped carrots</p>
<p class="noindent">1 cup coarsely chopped celery</p>
<p class="noindent">1 tablespoon finely chopped fresh rosemary</p>
<p class="noindent">One 14- to 15-ounce can plum tomatoes, with their juice</p>
<p class="noindent">¼ cup dry white wine</p>
<p class="noindent">2 medium zucchini, cut into ½-inch rounds</p>
<p class="noindent">One 14- to 15-ounce can small white beans, drained and rinsed</p>
<p class="noindent">1 head escarole or Savoy cabbage, cut into small pieces</p>
<p class="noindent">8 ounces green beans, ends snipped, cut into 1-inch pieces</p>
<p class="noindent">1 medium head cauliflower, cut into florets</p>
<p class="noindent">Rind from Parmigiano-Reggiano cheese, cut into ½-inch pieces, plus ½ to 1 cup finely grated Parmigiano-Reggiano cheese for garnishing</p>
<p class="noindent">2 cups vegetable broth</p>
<p class="noindent">1 teaspoon salt</p>
<p class="noindent">½ teaspoon freshly ground black pepper</p>
<p class="noindent">8 ounces cooked small pasta (shells, ditalini, or other short tubular pasta)</p>
<p class="noindent">heat the oil in a large skillet over medium-high heat. Add the garlic, onion, carrots, celery, and rosemary and sauté until the vegetables begin to soften, 4 to 5 minutes.</p>
<p class="noindent">add the tomatoes and wine and allow some of the liquid to evaporate in the pan.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Add the zucchini, white beans, cabbage, green beans, cauliflower, Parmigiano-Reggiano rind, broth, salt, and pepper.</p>
<p class="noindent">cover the slow cooker and cook on high for 3 to 4 hours or on low for 6 to 8 hours.</p>
<p class="noindent">stir in the cooked pasta at the end of the cooking time, cover, and set on warm until ready to serve.</p>
<p class="noindent">serve the soup garnished with the grated Parmigiano-Reggiano.</p>
<p class="noindent">serves 8</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011-chapter5.vue?1175c5e5